<div class="min-h-[70vh]">
  <app-loading *ngIf="isLoading"></app-loading>
  <div *ngIf="!isLoading" class="py-6 grid grid-cols-1 lg:grid-cols-3 gap-8">
    <aside
      class="bg-gray-50 rounded-xl p-6 space-y-4 text-gray-700 text-sm lg:col-span-1 order-2 lg:order-1"
    >
      <h2 class="text-lg font-semibold text-gray-800 mb-4">
        Información de la empresa
      </h2>
      <p class="line-clamp-2">
        <strong>Distrito:</strong> {{ company?.district || "Campo vacío" }}
      </p>
      <p class="line-clamp-2">
        <strong>Provincia:</strong> {{ company?.province || "Campo vacío" }}
      </p>
      <p class="line-clamp-2">
        <strong>Departamento:</strong>
        {{ company?.departament || "Campo vacío" }}
      </p>
      <p class="line-clamp-2">
        <strong>País:</strong> {{ company?.country || "Campo vacío" }}
      </p>
      <p class="line-clamp-2">
        <strong>Email:</strong> {{ company?.email || "Campo vacío" }}
      </p>
      <div class="pt-4 border-t border-gray-200">
        <h3 class="text-md font-medium text-gray-800 mb-5">Opciones</h3>
        <div
          *ngIf="company?.verified === '0'"
          class="relative w-full mb-8 p-4 border-2 border-red-500 bg-red-50 text-red-700 rounded shadow cursor-pointer group"
        >
          Su cuenta de compañía aún no está verificada.
          <div
            class="absolute left-1/2 top-full mt-2 w-72 -translate-x-1/2 rounded-md bg-white text-gray-700 text-sm shadow-lg p-3 opacity-0 group-hover:opacity-100 transition duration-200 border border-gray-300"
          >
            Para completar la verificación, haga clic en la sección ubicada
            <b>debajo del nombre de su compañía</b> y siga los pasos que allí se
            indican para activar la cuenta.
          </div>
        </div>
        <button
          *ngIf="company?.verified === '1'"
          (click)="openVerificationModal(company?.email || '')"
          class="w-full border border-primary text-primary mb-4 py-2 px-4 rounded shadow hover:bg-primary-700 transition duration-200 cursor-pointer"
        >
          Actualizar email
        </button>
      </div>
    </aside>
    <main class="lg:col-span-2 space-y-10 order-1 lg:order-2">
      <div
        class="bg-linear-to-r from-primary to-purple-600 text-white rounded-xl p-8 shadow"
      >
        <h3 class="text-2xl font-bold mb-2">Publica tus ofertas en Codijobs</h3>
        <p class="text-sm leading-relaxed line-clamp-2">
          Llega a miles de profesionales y encuentra el talento que tu empresa
          necesita. Descubre la sección de ofertas de trabajo y conecta con los
          mejores candidatos.
        </p>
      </div>
      <section class="relative border-b pb-10 border-gray-200">
        <button
          type="button"
          (click)="navigateUpdate()"
          aria-label="Editar datos básicos"
          class="absolute cursor-pointer top-4 right-4 bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary-dark transition"
        >
          <ng-icon name="featherEdit2" size="20"></ng-icon>
        </button>
        <h2 class="text-2xl font-semibold text-gray-800 mb-6">Datos básicos</h2>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 gap-6 text-gray-700 text-sm"
        >
          <div class="flex flex-col">
            <label class="text-gray-500 text-xs">Nombre comercial</label>
            <span class="font-medium">{{
              company?.commercialName || "Campo vacío"
            }}</span>
          </div>
          <div class="flex flex-col">
            <label class="text-gray-500 text-xs">Razón social</label>
            <span class="font-medium">{{
              company?.socialReason || "Campo vacío"
            }}</span>
          </div>
          <div class="flex flex-col">
            <label class="text-gray-500 text-xs">RUC</label>
            <span class="font-medium">{{ company?.ruc || "Campo vacío" }}</span>
          </div>
          <div class="flex flex-col">
            <label class="text-gray-500 text-xs">Línea de negocio</label>
            <span class="font-medium">{{
              company?.businessLine || "Campo vacío"
            }}</span>
          </div>
        </div>
      </section>
      <section class="relative pb-10">
        <h2 class="text-2xl font-semibold text-gray-800 mb-6">
          Información institucional
        </h2>
        <div class="space-y-8 text-gray-700 text-sm">
          <div>
            <label class="text-gray-500 text-xs">Slogan:</label>
            <p class="mt-1">
              {{ company?.slogan || "Campo vacío" }}
            </p>
          </div>
          <div>
            <label class="text-gray-500 text-xs">Misión:</label>
            <p class="mt-1">
              {{ company?.mission || "Campo vacío" }}
            </p>
          </div>
          <div>
            <label class="text-gray-500 text-xs">Visión:</label>
            <p class="mt-1">
              {{ company?.vision || "Campo vacío" }}
            </p>
          </div>
          <div>
            <label class="text-gray-500 text-xs">Nuestra historia:</label>
            <p class="mt-1">
              {{ company?.ourHistory || "Campo vacío" }}
            </p>
          </div>
          <div>
            <label class="text-gray-500 text-xs">Información comercial:</label>
            <p class="mt-1">
              {{ company?.businessInformation || "Campo vacío" }}
            </p>
          </div>
        </div>
      </section>
      <div class="relative rounded-md overflow-hidden">
        <h2 class="text-2xl font-semibold text-gray-800 mb-6">
          Banner de la empresa
        </h2>
        <img
          [src]="bannerCompany"
          alt="Banner de la empresa"
          class="w-full object-cover mt-3 rounded"
        />
        <button
          type="button"
          (click)="openModalUploadImage()"
          aria-label="Editar datos básicos"
          class="absolute shadow-2xl cursor-pointer top-0 right-4 bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary-dark transition"
        >
          <ng-icon name="featherEdit2" size="20"></ng-icon>
        </button>
      </div>
      <div class="relative rounded-md overflow-hidden">
        <h2 class="text-2xl font-semibold text-gray-800 mb-6">
          Imagen de equipo
        </h2>
        <img
          [src]="teamImage"
          alt="Imagen de equipo"
          class="w-full object-cover mt-3 border border-gray-200 rounded"
        />
        <button
          type="button"
          (click)="openModalTeamUploadImage()"
          aria-label="Editar datos básicos"
          class="absolute shadow-2xl cursor-pointer top-0 right-4 bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary-dark transition"
        >
          <ng-icon name="featherEdit2" size="20"></ng-icon>
        </button>
      </div>
    </main>
  </div>
</div>
<app-image-upload-modal
  [cropType]="'rectangle'"
  *ngIf="showModalUpdate"
  [loading]="modalLoading"
  (close)="showModalUpdate = false"
  (imageSelected)="uploadBanner($event)"
></app-image-upload-modal>
<app-image-upload-modal
  [cropType]="'rectangle2'"
  *ngIf="showImageTeamUpdate"
  [loading]="teamLoading"
  (close)="showImageTeamUpdate = false"
  (imageSelected)="uploadTeam($event)"
></app-image-upload-modal>
<app-update-email-modal
  *ngIf="showVerificationModal"
  #changeEmailModal
  [currentEmail]="company?.email || ''"
  (send)="handleSendCode($event)"
  (close)="closeVerificationModal()"
></app-update-email-modal>
